import type { TableData } from './types'

import {
  getTableBottomOffset,
  getTableTopOffset,
  getScrollingPosition,
} from './utils'

let tables: TableData[] = []

export const measureTables = (scrollableElement: Element | Window): void => {
  tables = []
  const headerElements: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.usr-repeated-header'
  )

  Array.from(headerElements).forEach((header, index) => {
    const table = header.closest('table')
    if (!table) {
      return
    }

    const headerPristineTop =
      header.getBoundingClientRect().top +
      getScrollingPosition(scrollableElement)

    tables.push({
      index,
      table,
      header,
      headerTopOriginal: headerPristineTop,
    })
  })
}

export const clearTables = (): void => {
  tables = []
}

export const getCorrectTable = (
  scrollableElement: Element | Window,
  hideSamepageHeader: boolean
): TableData | null => {
  const distance = getScrollingPosition(scrollableElement)

  const table = tables.find(
    (obj) =>
      distance >= getTableTopOffset(obj.table, scrollableElement) &&
      distance <= getTableBottomOffset(obj.table, scrollableElement)
  )

  //If we find a table, but none of the other tables should show headers, we return the first table
  if (table && hideSamepageHeader) return tables[0]
  return table || null
}
